import { useQuery } from "react-query";
import { useParams, useHistory } from "react-router-dom";
import "../Assets/scss/LiveGroups.scss";
import StdLiveNavBar from "../components/StdLiveNavBar";
import { developAxios } from "../axios.config";

function LiveGroups() {
	const { id } = useParams<{ id: string }>();
	const history = useHistory();

	const { data } = useQuery(
		["get-exam-grouping", id],
		() =>
			developAxios(localStorage.getItem("token") || "").get<{
				liveTrackerGrouping: {
					hybridExams: Array<{
						_id: string;
						nameoftheExam: string;
						courseId: {
							name: string;
							_id: string;
						};
					}>;
				} | null;
			}>("/live/getExamGrouping/hybrid/" + id),
		{
			onError: (err: any) => {
				if (err.response.status === 401) {
					history.push("/signin?redirect=/live-groups/" + id);
				}
			},
			enabled: !!id,
		}
	);

	console.log({ data });
	const color_array = ["orange-card", "grey-card", "blue-card", "pink-card"];
	return (
		<>
			<StdLiveNavBar />
			<div className="cards-grid">
				{data &&
					data.data.liveTrackerGrouping?.hybridExams.map(
						(val, index) => {
							let index_pos = index % 4;
							return (
								<GroupCards
									className={color_array[index_pos]}
									courseName={val.courseId.name}
									examId={val._id}
									examName={val.nameoftheExam}
								/>
							);
						}
					)}
			</div>
		</>
	);
}
interface IGroupCards {
	courseName: string;
	examName: string;
	examId: string;
	className: string;
}
function GroupCards({ className, examId, courseName, examName }: IGroupCards) {
	const history = useHistory();
	return (
		<div className={`group-cards-live ${className}`}>
			<span className="card-text-heading">{courseName}</span>
			<span className="card-text">{examName}</span>
			<button
				className="next-button"
				onClick={() => {
					history.push("/hybrid-exam-live/" + examId);
				}}
			>
				NEXT
			</button>
		</div>
	);
}
export default LiveGroups;
